import { Alert } from "@mui/material";
import { Form, Formik } from "formik";
import { Link } from "react-router-dom";
import { LoadingDots } from "components/shared/icons";
import { routes } from "constants/index";
import { SchoolSection } from "../components/SchoolSection";
import { SectionTitle } from "../components/SectionTitle";
import { FormSuccessPage } from "../FormSuccessPage/FormSuccessPage";
import { useSchoolLocal } from "../useSchoolLocal";
import { CountrySelect } from "./CountrySelect";
import { FormField } from "./FormField";
import { talkToAdvisorInitialValues, talkToAdvisorValidation } from "./formik";
import { useApiCall } from "./useApiCall";

export const TalkToAdvisor = () => {
  const { t, language } = useSchoolLocal();
  const { callApi, error, loading, success } = useApiCall();

  if (success) {
    return <FormSuccessPage />;
  }

  return (
    <SchoolSection contentClassName="py-10 md:py-14">
      <div className="mx-auto w-full max-w-[720px]">
        <SectionTitle className="mb-1.5">{t("connect.title")}</SectionTitle>
        <p className="mb-6 text-[15px] text-[#828282]">
          {t("connect.subtitle")}
        </p>
        {error && (
          <Alert severity="error" className="mb-4">
            {error}
          </Alert>
        )}
        <Formik
          initialValues={talkToAdvisorInitialValues}
          validationSchema={talkToAdvisorValidation(t)}
          onSubmit={(values) =>
            callApi("/api/school_landing/reach-out/", "POST", {
              ...values,
              language,
            })
          }
        >
          <Form noValidate className="flex flex-col gap-4">
            <div className="grid gap-4 sm:grid-cols-2">
              <FormField
                name="full_name"
                label={t("connect.fullName")}
                autoComplete="name"
                required
              />
              <FormField
                name="work_email"
                label={t("connect.workEmail")}
                type="email"
                autoComplete="email"
                required
              />
              <FormField
                name="school_name"
                label={t("connect.schoolName")}
                autoComplete="organization"
                required
              />
              <FormField
                name="job_title"
                label={t("connect.jobTitle")}
                autoComplete="organization-title"
                required
              />
              <CountrySelect name="country" label={t("connect.country")} />
              <FormField
                name="phone_number"
                label={t("connect.phoneNumber")}
                type="tel"
                autoComplete="tel"
                required
              />
            </div>
            <FormField
              name="explore_with_numuw"
              label={t("connect.exploreWithNumuw")}
              multiline
              required
            />
            <FormField
              name="additional_info"
              label={t("connect.additionalInfo")}
              multiline
            />
            <button
              type="submit"
              disabled={loading}
              className="mt-1 flex w-full items-center justify-center rounded-xl bg-[#4242CE] px-6 py-3.5 text-[16px] font-medium text-white transition-colors duration-200 hover:bg-[#4242CE]/90 disabled:opacity-70"
            >
              {loading ? (
                <span className="h-5 w-5">
                  <LoadingDots />
                </span>
              ) : (
                t("connect.send")
              )}
            </button>
            <p className="text-center text-xs text-[#828282]">
              {t("connect.privacyNotice")}{" "}
              <Link
                to={routes.privacyPolicy}
                className="text-[#4242CE] underline"
              >
                {t("connect.privacyPolicy")}
              </Link>
            </p>
          </Form>
        </Formik>
      </div>
    </SchoolSection>
  );
};
